import React from 'react';
import './style.scss';
import { usePersonalAccountOpenProfileDetails, useAdvanceQuestionValueModule} from './hooks';
import { useParams } from 'react-router-dom';

export const PersonalAccountOpenProfileDetails = () => {
  const { accountOpenProfileDetailsPageType, SwitchPage } = usePersonalAccountOpenProfileDetails();
  const { uniqueId } = useParams();

  useAdvanceQuestionValueModule(uniqueId);

  return (
    <>
      <div className="accountOpen">{SwitchPage(accountOpenProfileDetailsPageType)}</div>
    </>
  );
};
